export default __webpack_public_path__ + "static/space-6-e485c3dfa7b88ef9a701d5bf75ba2955.jpg";